import React, { useState } from 'react';
import AdminLayout from '../components/AdminLayout';
import { Settings, Bell, Shield, Globe, Database, FileText } from 'lucide-react';
import LegalDocumentsManager from '../components/LegalDocumentsManager';

export default function AdminSettings() {
  const [activeTab, setActiveTab] = useState<'general' | 'legal'>('general');

  return (
    <AdminLayout title="Configurações">
      <div className="mb-6">
        <div className="border-b border-gray-200">
          <nav className="flex -mb-px">
            <button
              onClick={() => setActiveTab('general')}
              className={`py-4 px-6 font-medium text-sm border-b-2 ${
                activeTab === 'general'
                  ? 'border-brand-teal text-brand-teal'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <div className="flex items-center gap-2">
                <Settings className="h-5 w-5" />
                <span>Configurações Gerais</span>
              </div>
            </button>
            <button
              onClick={() => setActiveTab('legal')}
              className={`py-4 px-6 font-medium text-sm border-b-2 ${
                activeTab === 'legal'
                  ? 'border-brand-teal text-brand-teal'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <div className="flex items-center gap-2">
                <FileText className="h-5 w-5" />
                <span>Documentos Legais</span>
              </div>
            </button>
          </nav>
        </div>
      </div>

      {activeTab === 'general' ? (
        <div className="space-y-6">
          {/* Configurações Gerais */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center gap-3 mb-6">
              <Settings className="h-6 w-6 text-brand-teal" />
              <h2 className="text-xl font-semibold text-brand-teal">Configurações Gerais</h2>
            </div>
            
            <div className="space-y-4">
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div>
                  <h3 className="font-medium text-gray-700">Nome da Igreja</h3>
                  <p className="text-sm text-gray-600">Nome exibido em todo o aplicativo</p>
                </div>
                <input
                  type="text"
                  value="Igreja Sal da Terra BSB"
                  className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-teal focus:border-brand-teal"
                />
              </div>

              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div>
                  <h3 className="font-medium text-gray-700">Fuso Horário</h3>
                  <p className="text-sm text-gray-600">Fuso horário padrão para eventos</p>
                </div>
                <select className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-teal focus:border-brand-teal">
                  <option>America/Sao_Paulo</option>
                  <option>America/Manaus</option>
                  <option>America/Belem</option>
                </select>
              </div>
            </div>
          </div>

          {/* Configurações de Notificação */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center gap-3 mb-6">
              <Bell className="h-6 w-6 text-brand-teal" />
              <h2 className="text-xl font-semibold text-brand-teal">Configurações de Notificação</h2>
            </div>
            
            <div className="space-y-4">
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div>
                  <h3 className="font-medium text-gray-700">Notificações Push</h3>
                  <p className="text-sm text-gray-600">Habilitar notificações push</p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" className="sr-only peer" defaultChecked />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-brand-light rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-brand-teal"></div>
                </label>
              </div>

              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div>
                  <h3 className="font-medium text-gray-700">Notificações por Email</h3>
                  <p className="text-sm text-gray-600">Habilitar notificações por email</p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" className="sr-only peer" defaultChecked />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-brand-light rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-brand-teal"></div>
                </label>
              </div>
            </div>
          </div>

          {/* Configurações de Segurança */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center gap-3 mb-6">
              <Shield className="h-6 w-6 text-brand-teal" />
              <h2 className="text-xl font-semibold text-brand-teal">Configurações de Segurança</h2>
            </div>
            
            <div className="space-y-4">
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div>
                  <h3 className="font-medium text-gray-700">Autenticação em Duas Etapas</h3>
                  <p className="text-sm text-gray-600">Requer verificação adicional ao fazer login</p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" className="sr-only peer" />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-brand-light rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-brand-teal"></div>
                </label>
              </div>

              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div>
                  <h3 className="font-medium text-gray-700">Tempo de Sessão</h3>
                  <p className="text-sm text-gray-600">Tempo até o logout automático</p>
                </div>
                <select className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-teal focus:border-brand-teal">
                  <option>30 minutos</option>
                  <option>1 hora</option>
                  <option>4 horas</option>
                  <option>8 horas</option>
                </select>
              </div>
            </div>
          </div>

          {/* Configurações do Site */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center gap-3 mb-6">
              <Globe className="h-6 w-6 text-brand-teal" />
              <h2 className="text-xl font-semibold text-brand-teal">Configurações do Site</h2>
            </div>
            
            <div className="space-y-4">
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div>
                  <h3 className="font-medium text-gray-700">Modo de Manutenção</h3>
                  <p className="text-sm text-gray-600">Ativar página de manutenção</p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" className="sr-only peer" />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-brand-light rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-brand-teal"></div>
                </label>
              </div>

              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div>
                  <h3 className="font-medium text-gray-700">Cache do Site</h3>
                  <p className="text-sm text-gray-600">Limpar cache do site</p>
                </div>
                <button className="px-4 py-2 bg-brand-teal text-white rounded-lg hover:bg-brand-teal/90 transition-colors">
                  Limpar Cache
                </button>
              </div>
            </div>
          </div>

          {/* Configurações do Banco de Dados */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center gap-3 mb-6">
              <Database className="h-6 w-6 text-brand-teal" />
              <h2 className="text-xl font-semibold text-brand-teal">Configurações do Banco de Dados</h2>
            </div>
            
            <div className="space-y-4">
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div>
                  <h3 className="font-medium text-gray-700">Backup Automático</h3>
                  <p className="text-sm text-gray-600">Realizar backup diário do banco de dados</p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" className="sr-only peer" defaultChecked />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-brand-light rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-brand-teal"></div>
                </label>
              </div>

              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div>
                  <h3 className="font-medium text-gray-700">Backup Manual</h3>
                  <p className="text-sm text-gray-600">Realizar backup do banco de dados agora</p>
                </div>
                <button className="px-4 py-2 bg-brand-teal text-white rounded-lg hover:bg-brand-teal/90 transition-colors">
                  Fazer Backup
                </button>
              </div>
            </div>
          </div>

          {/* Botões de Ação */}
          <div className="flex justify-end gap-4">
            <button className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
              Cancelar
            </button>
            <button className="px-6 py-2 bg-brand-teal text-white rounded-lg hover:bg-brand-teal/90 transition-colors">
              Salvar Alterações
            </button>
          </div>
        </div>
      ) : (
        <LegalDocumentsManager />
      )}
    </AdminLayout>
  );
}